import React, { useEffect } from 'react';
import ImgCrop from 'antd-img-crop';
import { Upload } from 'antd';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import { Button } from 'antd';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/Help';
import RenameDialog from './RenameDialog';

const audioOptions = ['Single', 'Album'];

export default function UploadFilesStep({
  imageFile,
  dummyRequest,
  onChangeImage,
  onPreview,
  formStep,
  steps,
  next,
  prev,
  loadingMintBtn,
  nftDetails,
  onUpdateNFTtype,
  onChange,
  audioCoverFile,
  setaudioCoverFile,
  onChangeAudioCoverImage,
  onChangeSampleAudioFile,
  sampleAudioFile,
  setimageFile,
  renameDialogState,
  setrenameDialogState,
  renameAudioFileName,
  setaudioFileNames,
  audioFileNames,
}) {
  const renderStepperActions = () => {
    const { governingLaw, terms } = nftDetails;
    return (
      <>
        {formStep > 0 && (
          <Button
            className="step_btn_btn"
            style={{ margin: '0 8px' }}
            onClick={() => prev()}
          >
            Prev
          </Button>
        )}
        {formStep < steps.length - 1 && (
          <Button
            className="step_btn_btn"
            disabled={!imageFile.length}
            type="primary"
            onClick={() => {
              next();
            }}
          >
            Next
          </Button>
        )}
      </>
    );
  };

  return (
    <>
      <div className="row steps-content-inner-wrapper">
        <div className="w-full px-4 text-left">
          <h4 className="sign__title">Upload files</h4>
        </div>

        {nftDetails.nftType === 'Audio' ? (
          <>
            <div className="w-full my-4">
              <div className="w-full md:w-6/12 px-4">
                <div className="sign__group">
                  <label className="upld__label" htmlFor="Category-field">
                    Audio type <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="Category-field"
                    name="audioType"
                    className="sign__select"
                    value={nftDetails.audioType}
                    onChange={(e) => {
                      onChange(e);
                      setimageFile([]);
                      setaudioFileNames([]);
                    }}
                    required="required"
                  >
                    {audioOptions.map((ele) => (
                      <option className="sign_option" value={ele}>
                        {ele}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            {/* //audio cover */}
            <div
              className="w-full md:w-6/12 text-left px-4 my-20"
              style={{ position: 'relative' }}
            >
              <div
                className="sign__group upload_wrapper"
                style={{
                  zIndex: 2,
                }}
              >
                <label className="upld__label">
                  NFT Audio Cover <span className="text-red-500">*</span>
                  {/* <span className="text-red-500">*</span> */}
                  <br />
                  (JPG, GIF, PNG)
                  <br />
                </label>
                <ImgCrop
                  rotate
                  beforeCrop={(file) => {
                    if (
                      file.type === 'image/gif' ||
                      file.type === 'video/mp4'
                    ) {
                      return false;
                    } else {
                      return true;
                    }
                  }}
                >
                  <Upload
                    customRequest={dummyRequest}
                    listType="picture-card"
                    fileList={audioCoverFile}
                    onChange={onChangeAudioCoverImage}
                    onPreview={onPreview}
                    required
                    accept={'image/*'}
                  >
                    {audioCoverFile.length < 2 && <AddOutlinedIcon />}
                  </Upload>
                </ImgCrop>
              </div>

              {!audioCoverFile || !audioCoverFile[0] ? (
                <div
                  style={{
                    zIndex: 1,
                    position: 'absolute',
                    top: '40%',
                    opacity: 0,
                    visibility: 'hidden',
                  }}
                >
                  <input
                    type="file"
                    required={
                      audioCoverFile && audioCoverFile[0] ? false : true
                    }
                  />
                </div>
              ) : (
                <></>
              )}
            </div>{' '}
            {/* //sample audio file */}
            <div
              className="w-full md:w-6/12 text-left px-4 my-20"
              style={{ position: 'relative' }}
            >
              <div
                className="sign__group upload_wrapper"
                style={{
                  zIndex: 2,
                }}
              >
                <label className="upld__label">
                  NFT Sample Audio File <span className="text-red-500">*</span>
                  <Tooltip
                    enterTouchDelay={0}
                    title="Please upload a sample of max 20 sec."
                  >
                    <HelpIcon
                      style={{
                        fontSize: 18,
                        marginLeft: 10,
                        position: 'absolute',
                      }}
                    />
                  </Tooltip>
                  <br />
                  (MP3) <br />
                </label>
                <ImgCrop
                  rotate
                  beforeCrop={(file) => {
                    if (
                      file.type === 'image/gif' ||
                      file.type === 'video/mp4' ||
                      file.type.includes('audio')
                    ) {
                      return false;
                    } else {
                      return true;
                    }
                  }}
                >
                  <Upload
                    customRequest={dummyRequest}
                    listType="picture-card"
                    fileList={sampleAudioFile}
                    onChange={onChangeSampleAudioFile}
                    onPreview={onPreview}
                    required
                    accept={'audio/*'}
                  >
                    {sampleAudioFile.length < 1 && <AddOutlinedIcon />}
                  </Upload>
                </ImgCrop>
              </div>

              {!sampleAudioFile || !sampleAudioFile[0] ? (
                <div
                  style={{
                    zIndex: 1,
                    position: 'absolute',
                    top: '40%',
                    opacity: 0,
                    visibility: 'hidden',
                  }}
                >
                  <input
                    type="file"
                    required={
                      sampleAudioFile && sampleAudioFile[0] ? false : true
                    }
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
            {/* //audio file */}
            <div
              className="w-full text-left px-4 my-20"
              style={{ position: 'relative' }}
            >
              <div
                className="sign__group upload_wrapper"
                style={{
                  zIndex: 2,
                }}
              >
                <label className="upld__label">
                  NFT Audio File <span className="text-red-500">*</span>
                  <br />
                  (MP3) <br />
                  {nftDetails.audioType === 'Album' &&
                    'You can select max 10 audio files'}
                </label>
                <ImgCrop
                  rotate
                  beforeCrop={(file) => {
                    if (
                      file.type === 'image/gif' ||
                      file.type === 'video/mp4' ||
                      file.type.includes('audio')
                    ) {
                      return false;
                    } else {
                      return true;
                    }
                  }}
                >
                  <Upload
                    customRequest={dummyRequest}
                    listType="picture-card"
                    fileList={imageFile}
                    onChange={onChangeImage}
                    onPreview={onPreview}
                    required
                    accept={'audio/*'}
                  >
                    {(() => {
                      if (nftDetails.audioType === 'Single') {
                        return imageFile.length < 1 && <AddOutlinedIcon />;
                      } else if (nftDetails.audioType === 'Album') {
                        return imageFile.length < 10 && <AddOutlinedIcon />;
                      }
                    })()}
                  </Upload>
                </ImgCrop>
              </div>

              {!imageFile || !imageFile[0] ? (
                <div
                  style={{
                    zIndex: 1,
                    position: 'absolute',
                    top: '40%',
                    opacity: 0,
                  }}
                >
                  <input
                    type="file"
                    required={imageFile && imageFile[0] ? false : true}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          </>
        ) : (
          <div
            className="w-full text-left px-4 my-20"
            style={{ position: 'relative' }}
          >
            <div
              className="sign__group upload_wrapper"
              style={{
                zIndex: 2,
              }}
            >
              <label className="upld__label">
                NFT {nftDetails.nftType === 'Image' ? 'Image/Gif' : 'Video'}{' '}
                <span className="text-red-500">*</span>
                <br />
                {nftDetails.nftType === 'Image' ? '(JPG, GIF, PNG)' : '(MP4)'}
                <br />
                If you have a back cover, upload a second{' '}
                {nftDetails.nftType === 'Image' ? 'image' : 'video'}.
              </label>
              <ImgCrop
                rotate
                beforeCrop={(file) => {
                  if (file.type === 'image/gif' || file.type === 'video/mp4') {
                    return false;
                  } else {
                    return true;
                  }
                }}
              >
                <Upload
                  customRequest={dummyRequest}
                  listType="picture-card"
                  fileList={imageFile}
                  onChange={onChangeImage}
                  onPreview={onPreview}
                  required
                  accept={
                    nftDetails.nftType === 'Image' ? 'image/*' : 'video/*'
                  }
                >
                  {imageFile.length < 2 && <AddOutlinedIcon />}
                </Upload>
              </ImgCrop>
            </div>

            {!imageFile || !imageFile[0] ? (
              <div
                style={{
                  zIndex: 1,
                  position: 'absolute',
                  top: '40%',
                  opacity: 0,
                }}
              >
                <input
                  type="file"
                  required={imageFile && imageFile[0] ? false : true}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        )}

        {/* //mint btn */}
        <div className="w-full mt-4">
          <div className="w-full xl:w-3/12 px-4">
            {loadingMintBtn ? (
              <div
                className="flex justify-center	 sign__btn"
                style={{ backgroundColor: 'transparent' }}
              >
                <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
              </div>
            ) : (
              <button
                type="submit"
                className={`sign__btn ${
                  !imageFile.length ? 'disable_btn' : ''
                }`}
                disabled={!imageFile.length}
                form="minting-form"
              >
                Mint NFT
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="steps-action px-4">{renderStepperActions()}</div>
      <RenameDialog
        dialogState={renameDialogState}
        setdialogState={setrenameDialogState}
        renameAudioFileName={renameAudioFileName}
        setaudioFileNames={setaudioFileNames}
        audioFileNames={audioFileNames}
        imageFile={imageFile}
        setimageFile={setimageFile}
      />
    </>
  );
}
